import { useTableConstructor } from "layout/TableConstructor/context/tableConstructorContext";
import { Identifiable } from "layout/TableConstructor/types";
import CustomModal from "components/modals/CustomModal";
import { Stack } from "@mui/material";
import React, { useState } from "react";
import Checkbox from "components/form/CheckboxControl/components/Checkbox";

interface ColumnSettingsModalProps {
  open: boolean;
  onClose: () => void;
  storageName: string;
  title: string;
}

const ColumnSettingsModal = <T extends Identifiable, AvailableFilters extends object, OrderField extends string>(
  props: ColumnSettingsModalProps
) => {
  const { open, onClose, storageName, title } = props;
  const { visibleColumnList, setVisibleColumnList, columnConfigList, setVisibleFilterList } = useTableConstructor<
    T,
    AvailableFilters,
    OrderField
  >();

  const [selectedColumnList, setSelectedColumnList] = useState<string[]>(visibleColumnList);

  const onSaveColumnSettings = () => {
    setVisibleColumnList(selectedColumnList);
    const visibleFilterList = selectedColumnList.reduce((acc: (keyof AvailableFilters | string)[], columnName) => {
      const filterName = columnConfigList.find((c) => c.name === columnName)?.filterName;
      if (filterName) acc.push(filterName);
      return acc;
    }, []);
    setVisibleFilterList(visibleFilterList);
    localStorage.setItem(storageName, JSON.stringify(selectedColumnList));
    onClose();
  };

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title={title}
      buttonText='Применить'
      handleClick={onSaveColumnSettings}
      content={
        <Stack spacing={1}>
          {columnConfigList.map((column) => (
            <Checkbox
              sx={{ ml: 0 }}
              key={column.name}
              value={selectedColumnList.includes(column.name)}
              handleChange={(checked) => {
                if (checked) {
                  setSelectedColumnList((prev) => [...prev, column.name]);
                } else {
                  setSelectedColumnList((prev) => prev.filter((filterName) => filterName !== column.name));
                }
              }}
              label={column.title}
            />
          ))}
        </Stack>
      }
    />
  );
};

export default ColumnSettingsModal;
